export default __webpack_public_path__ + "static/media/svamp.8dfcc0ce.jpg";